export var DataMonitorPermission;
(function (DataMonitorPermission) {
    DataMonitorPermission[DataMonitorPermission["Read"] = 4] = "Read";
    DataMonitorPermission[DataMonitorPermission["Write"] = 2] = "Write";
    DataMonitorPermission[DataMonitorPermission["ReadWrite"] = 6] = "ReadWrite";
})(DataMonitorPermission || (DataMonitorPermission = {}));
